/**
 * Simple in-memory cache for API responses.
 * Session-scoped (clears on page reload).
 * staleTime: Infinity by default - data never expires on its own.
 * Invalidation happens only on create/edit/delete mutations.
 */
const store = new Map();

export function getCached(key) {
  const entry = store.get(key);
  if (!entry) return null;
  // Infinity staleTime = never expires
  if (entry.staleTime !== Infinity && Date.now() - entry.ts > entry.staleTime) {
    store.delete(key);
    return null;
  }
  return entry.data;
}
// Expose store for stale-while-revalidate timestamp checks
getCached.__store = store;

export function setCache(key, data, staleTime = Infinity) {
  store.set(key, { data, ts: Date.now(), staleTime });
}

export function invalidate(...prefixes) {
  for (const key of store.keys()) {
    if (prefixes.some(p => key.startsWith(p))) {
      store.delete(key);
    }
  }
}

export function clearAll() {
  store.clear();
}

/** Pre-fetch data into cache for a future route */
export function prefetch(key, fetcher) {
  if (getCached(key)) return; // already cached
  fetcher().then(data => setCache(key, data)).catch(() => {});
}
